import {BaseModel} from '../base.model';
import {required} from '../json-map.util';

class UserRequest {}

namespace UserRequest {

  export class Login extends BaseModel {
    @required()
    email: string = undefined;
    @required()
    password: string = undefined;
  }

  export class UserInfo extends BaseModel{
    auth0Id: string = undefined;
    appMetadata: any = undefined;
    email: string = undefined;
  }

  export class Signup extends BaseModel {
    email: string = undefined;
    password: string = undefined;
    firstName: string = undefined;
    lastName: string = undefined;
    phoneNumber: string = undefined;
  }

  export class UpdateProfile extends BaseModel {
    @required()
    email: string = undefined;
    firstName: string = undefined;
    lastName: string = undefined;
    birthYear: string = undefined;
    gender: string = undefined;
    address1: string = undefined;
    address2: string = undefined;
    city: string = undefined;
    state: string = undefined;
    postalCode: string = undefined;

  }


}

export { UserRequest };
